
import React, { useState, useEffect  } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DatePicker from "react-datepicker";
import toastr from 'toastr';
import getDt, { getDtfrmt } from '../../utils';
import { showLoader } from '../redux/ctrl/ctrlActions';
import { updatePrjAsn } from '../redux/prjasn/prjAsnActions';
import { CREATE_PRJASN } from '../redux/prjasn/prjAsnTypes';
import "react-datepicker/dist/react-datepicker.css";
import './Permission.scss';
import "toastr/build/toastr.min.css";
//import { sendMailStart } from '../redux/project/projActions';
//import { envInstance,notiPL, accessURL } from './emailNotification';
import { useTranslation } from 'react-i18next';

function PermissionDates(props) {
    const dispatch = useDispatch();
    const [isOpen,setIsOpen] = useState(false);
    const userData = useSelector(state => state.prjasn.userData); 
    const[writeAcc2,setWriteAcc2]=useState();
    const profile = useSelector((state) => state.profile);
    const uptag= useSelector(state => state.prjasn.projectsAsn);
    const ctrlState = useSelector((state) => state.ctrl);
    const { t, i18n } = useTranslation();

    const onPermissionChange = (date) => {
        setIsOpen(false);
        if(date.target!==undefined){
            const target = date.target;
            date=target.value;
            if(date!=='')return;
            target.value='';
        }
        const pl = props.data;
        if (date === "" && props.column.colDef.field === "start_date") {
            toastr.error(t('Start date should not be null'));
            return;
        }
        pl[props.column.colDef.field] = date !== null ? getDt(date) : date;
        pl.start_date = pl.start_date !== null ? getDt(pl.start_date) : null;
        pl.end_date = props.column.colDef.field === "start_date" ? null : pl.end_date !== null ? getDt(pl.end_date) : null;
        
        if (pl.project_assign_id) {
            dispatch(showLoader(true))
            //console.log("pl",pl)
        //     const end_date = pl.end_date?.split(' ')[0] || '';
        //     const toUser = {
        //         TemplateCode: 'ASSIGN_PROJECT',
        //         Label1: 'Contact_Name',
        //         Value1: `${pl.first_name}`,
        //         Label2: 'Grantor_Name',
        //         Value2: profile.givenName,
        //         Label3: 'env',
        //         Value3: envInstance.envName,
        //         Label4: 'Last_Name',
        //         Value4: pl.last_name,
        //         Label5: 'Read_Access',
        //         Value5: pl.read_access,
        //         Label6: 'Write_Access',
        //         Value6: pl.write_access,
        //         Label7: 'Start_Date',
        //         Value7: pl.start_date.split(' ')[0],
        //         Label9: 'Assigned_By',
        //         Value9: profile.givenName,
        //         Label10: 'Project_Name',
        //         Value10: pl.project_name,
        //         toMailAddress:pl.email_id,
        //         ccMailAddress:profile.email,
        //         bccMailAddress: '',
        //         Subject: '',
        //         Body: '',
        //         Signature: '',
        //         Attachment: [{
        //             contentType: '',
        //             filecontent: '',
        //             filename: '',
        //         }],
        //     };
        //     if (end_date) {
        //         toUser.Label8 = 'End_Date';
        //         toUser.Value8 = end_date;
        //     }
           
        //    dispatch(sendMailStart(toUser));
            dispatch(updatePrjAsn(pl))
            setIsOpen(false)
            //dispatch(showLoader(false))
        }
        else {
            const updatedUserData = []
            userData.map((data) => {
                if(data.email_id === pl.email_id) {
                    updatedUserData.push(pl)
                } else {
                    updatedUserData.push(data)
                }
            });
            dispatch({ type: CREATE_PRJASN, userData: [...updatedUserData] })
        }
    }

    var timer;
    const handleDblClick = (event) => {
        setIsOpen(false)
        clearTimeout(timer);
        if (event.detail === 1) {
        timer = setTimeout(() => {
            setIsOpen(false)
        }, 200)

        } else if (event.detail === 2) {
            setIsOpen(true)
        }
    }

    useEffect(() => {
        let write_accsNew = uptag.filter((item) => item.project_id === ctrlState.data?.project_id && profile.email===item.email_id)[0]?.write_access
        write_accsNew =  ctrlState.data.created_by==profile.email || write_accsNew=='Y' ?true:false
        setWriteAcc2(write_accsNew)
    },[uptag,ctrlState.data]);

    const CustomInput = React.forwardRef(() => {
        return(
            <>
                <input type="text" 
                disabled={props.column.colDef.field === 'start_date'}
                // disabled={props.data.project_assign_id && props.column.colDef.field === 'start_date' ? true : false || props.writeAcc ? false:true} 
                className="react-datepicker dtwdt" placeholder="DD-MMM-YYYY"
                    defaultValue={props.data[props.column.colDef.field] ? getDtfrmt(new Date(props.data[props.column.colDef.field])): null}
                    onClick={(event)=>handleDblClick(event)} onChange={(event) => {onPermissionChange(event)}}
            />
            </>
        )
    });
    
    return (
        <DatePicker
            name={props.column.colDef.field} portalId="root"
            onChange={(date) => {onPermissionChange(date)}}
            minDate={props.column.colDef.field === "end_date" ? new Date(props.data.start_date) : null}
            valueDefault={null}
            className="react-datepicker dtwdt"
            popperClassName="ag-custom-component-popup"
            dateFormat="dd-MMM-yyyy" dropdownMode="select"
            showMonthDropdown showYearDropdown
            open={isOpen} fixedHeight
            customInput={(<CustomInput/>)}
            onClickOutside={()=>setIsOpen(false)}
        />
        /*<DatePicker selected={props.data[props.column.colDef.field] ? new Date(props.data[props.column.colDef.field]) : null}
            name={props.column.colDef.field}
            portalId="root"
            onChange={date => onPermissionChange(date)}
            minDate={props.column.colDef.field === "end_date" ? new Date(props.data.start_date) : null}
            valueDefault={null}
            className="react-datepicker dtwdt"
            popperClassName="ag-custom-component-popup"
            placeholderText="DD-MMM-YYYY"
            dateFormat="dd-MMM-yyyy"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
    fixedHeight />*/
    )
}

export default PermissionDates;